import { render } from "./settings_storage.vue?vue&type=template&id=7410e7bb"
import script from "./settings_storage.vue?vue&type=script&lang=js"
export * from "./settings_storage.vue?vue&type=script&lang=js"
script.render = render

export default script